/**
 * UnassignDialog — Confirmation dialog for unassigning/deactivating a device.
 */

const UnassignDialog = ({ onClose, onConfirm, saving }) => {
  return (
    <div className="pp-dialog-backdrop" onClick={onClose}>
      <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="pp-dialog__header">
          <h2 className="pp-dialog__title">Unassign Device</h2>
          <button className="dp-drawer__close" onClick={onClose}>✕</button>
        </div>
        <div className="pp-dialog__body">
          <p className="pp-dialog__text">
            Are you sure you want to unassign this device? It will be unattached from any
            associated area or resident and will no longer be monitored by the system.
          </p>
        </div>
        <div className="pp-dialog__footer">
          <button
            className="dp-btn dp-btn--cancel"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            className="dp-btn dp-btn--danger"
            onClick={onConfirm}
            disabled={saving}
          >
            {saving ? 'Unassigning…' : 'Yes, Unassign'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnassignDialog;
